module.exports = __webpack_public_path__ + "static/media/14-iveco.4274e36b.jpg";